<div class="location-data">            
    <div class="label">
        <label>
            Location Details
        </label>
    </div>
    <div class="information">
        <div class="text">
            <span class="key">Location Type: </span>
            <span class="value">{{locationData.locationType?locationData.locationType: "N/A"}}</span>
        </div>
    </div>

    <div class="label">
        <label>
            Contact Details
        </label>
    </div>
    <div class="information">
        <div class="text">
            <span *ngIf="locationData.pickupAppointement">
                <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1805,24,24))"
                    style="width:20px;height:20px" type="image/svg+xml">
            </span>
            <span *ngIf="!locationData.pickupAppointement">
                <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))"
                    style="width:20px;height:20px" type="image/svg+xml">
            </span>
            <span class="key">
                pickup appointment required
            </span>
            <span class="value"></span>
        </div>
        <div class="text">            
            <span *ngIf="locationData._24HourCall">
                <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1805,24,24))"
                    style="width:20px;height:20px" type="image/svg+xml">
            </span>
            <span *ngIf="!locationData._24HourCall">                
                <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))"
                    style="width:20px;height:20px" type="image/svg+xml">
            </span>
            <span class="key">
                24 hours call required
            </span>
            <span class="value"></span>
        </div>
        <div class="text">
            <span *ngIf="locationData.isTWICRequired">
                <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1805,24,24))"
                    style="width:20px;height:20px" type="image/svg+xml">
            </span>
            <span *ngIf="!locationData.isTWICRequired">
                <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))"
                    style="width:20px;height:20px" type="image/svg+xml">
            </span>
            <span class="key">
                Needs TWIC
            </span>
            <span class="value"></span>
        </div>
        <div class="text">
            <span *ngIf="locationData.tdlr">
                <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1805,24,24))"
                    style="width:20px;height:20px" type="image/svg+xml">
            </span>
            <span *ngIf="!locationData.tdlr">
                <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))"
                    style="width:20px;height:20px" type="image/svg+xml">
            </span>
            <span class="key">
                Needs TDLR
            </span>
            <span class="value"></span>
        </div>
    </div>

    <div class="label">
        <label>
            Operational hours
        </label>
    </div>
    <div class="information operational-hours">
        <div class="text office-hours">
            <label>Office
                Hours</label>

            <div *ngIf="officeHours.length;else noOfficeHours">
                <div class="hours-content" *ngFor="let day of officeHours; let i = index;">
                    <span>{{day.key}}: </span>
                    <span *ngIf="day.closed;else open">Closed</span>
                    <ng-template #open>
                        <span class="value" *ngIf="day.value;else na">{{day.value}} </span>
                        <ng-template #na>
                            <span class="value"> N/A</span>
                        </ng-template>
                    </ng-template>    
                </div>
            </div>
            <ng-template #noOfficeHours>
                <div class="no-data">
                    N/A
                </div>
            </ng-template>
        </div>
        <div class="loading-hours text">
            <label>Loading
                Hours</label>


            <div *ngIf="loadingHours.length;else noLoadingHours">
                <div class="hours-content" *ngFor="let day of loadingHours; let i = index;">
                    <span>{{day.key}}: </span>
                    <span *ngIf="day.closed;else open">Closed</span>
                    <ng-template #open>
                        <span class="value" *ngIf="day.value;else na">{{day.value}} </span>
                        <ng-template #na>
                            <span class="value"> N/A</span>
                        </ng-template>
                    </ng-template>                    
                </div>
            </div>
            <ng-template #noLoadingHours>
                <div class="no-data">
                    N/A
                </div>
            </ng-template>                
        </div>
    </div>
    <div class="extra-info">
        <div class="text">
            <span *ngIf="locationData.w9FormFlag">
                <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1805,24,24))"
                    style="width:20px;height:20px" type="image/svg+xml">
            </span>
            <span *ngIf="!locationData.w9FormFlag">
                <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))"
                    style="width:20px;height:20px" type="image/svg+xml">
            </span>
            <span class="key">
                W9 Form
            </span>
        </div>
        <div class="text" >
            <span *ngIf="locationData.sirFormFlag">
                <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1805,24,24))"
                    style="width:20px;height:20px" type="image/svg+xml">
            </span>
            <span *ngIf="!locationData.sirFormFlag">
                <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))"
                    style="width:20px;height:20px" type="image/svg+xml">
            </span>
            <span class="key">
                SIR Form
            </span>
        </div>
        <div class="location-restriction">
            Location Restriction:
            <span *ngIf="locationData.locationRestrictions;else noLocationRestrictions">{{locationData.locationRestrictions}}</span>
            <ng-template #noLocationRestrictions>
                <span>N/A</span>
            </ng-template>
        </div>
    </div>
</div>
